import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import SliderManager from '../../../../components/Editor/EditPanel/SliderManager';

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos: { config } } = state;

	return {
		config,
	};
};

export default connect(mapStateToProps)(SliderManager);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SliderManager/index.tsx